import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {shuffleArray} from 'helpers/array-helpers';
import {uiTexts} from 'data/ui-texts';
import {citiesData} from 'data/cities-data';
import LanguageIcons from 'components/ui/language-icons/language-icons';
import './favorites.scss';

const Favorites = ({type, languageId, deviceInfo, rooms}) => {

	const goldRooms = shuffleArray(rooms.filter((r) => {return r.heart === 'gold';}));
	const silverRooms = shuffleArray(rooms.filter((r) => {return r.heart === 'silver';}));
	const bronzeRooms = shuffleArray(rooms.filter((r) => {return r.heart === 'bronze';}));


	return (
		<div className={'Favorites ' + deviceInfo.orientation + (type ? ' ' + type : '')}>

			{/* Gold rooms */}
			<div className="Favorites-section gold">
				<div className="Favorites-title"><span>{uiTexts.goldRoomsTitle[languageId]}</span></div>
				<div className="Favorites-rooms">
					{goldRooms.map((room) => {
						/* Get room image */
						let bgImg = require('../../assets/images/default.jpg');
						try {
							bgImg = require('../../assets/images/rooms/' + room.venueData.id + '_' + room.id + '.jpg');
						} catch (e) {
							console.error('Could not find image: ' + room.venueData.id + '_' + room.id + '.jpg');
						}

						/* Get venue name */
						let venueName = room.venueData.name;

						/* Get venue website */
						let website = null;
						if (room.venueData.website) {
							website = room.venueData.website
								.replace('https://www.', '')
								.replace('http://www.', '')
								.replace('http://', '')
								.replace('https://', '')
								.replace('www.', '');	
						}

						/* Add city name to venue name if it is not already in the name */
						if (room.locations && room.locations.length > 1) {
							venueName += ', ' + uiTexts.multipleCities[languageId];
						} else if (room.locations && room.locations.length === 1) {
							const locationData = 
								room.venueData.locations.find((l) => {return l.id === room.locations[0].locationId;});
							if (locationData) {
								const cityData = citiesData.find((c) => {return c.id === locationData.cityId;});
								const cityName = cityData ? cityData.name[languageId] : null;
								if (cityName && venueName.toLowerCase().indexOf(cityName.toLowerCase()) < 0) {
									venueName += ', ' + cityName;
								}
							}
						}
						
			
						/* Get link to venue */
						let linkTo = '/' + room.venueData.id;

						return (
							<div 
								key={room.venueData.id + '-' + room.id} 
								className={'Favorites-room' + (room.heart ? ' ' + room.heart : '')}
								style={{backgroundImage: 'url(' + bgImg + ')'}}
							>					
								<div className="Favorites-roomInfo">
									<div className="Favorites-roomName">{room.name[languageId]}</div>
									<Link className="Favorites-venueName" to={linkTo}>{venueName}</Link>
									<div className="Favorites-extraInfo">
										<div>
											<span>{uiTexts.teamSize[languageId]}:</span> 
											{' ' + (room.teamSizeMin === room.teamSizeMax 
												? room.teamSizeMin 
												: room.teamSizeMin + ' - ' 
													+ room.teamSizeMax)} {uiTexts.players[languageId]
											}
										</div>
										<div>
											<span>{uiTexts.timeLimit[languageId]}:</span>
											{' ' + room.minutes} {uiTexts.minutes[languageId]}
										</div>
										{room.languages && <div>
											<span>{uiTexts.languages[languageId]}:</span> 
											<LanguageIcons languageId={languageId} languageIds={room.languages} />
										</div>}
										{room.minimumAge && 
											<div><span>{uiTexts.age[languageId]}:</span> {room.minimumAge + '+'}</div>}
										{room.venueData.website && <div className="Favorites-website">
											<span>
												{uiTexts.website[languageId]}:</span> <a 
												href={room.venueData.website}
												target="_blank"
												rel="noopener noreferrer"	
											>{website}</a>
										</div>}
									</div>
								</div>
							</div>
						);
					})}
				</div>
			</div>

			{/* Silver rooms */}
			<div className="Favorites-section silver">
				<div className="Favorites-title"><span>{uiTexts.silverRoomsTitle[languageId]}</span></div>
				<div className="Favorites-rooms">
					{silverRooms.map((room) => {
						/* Get room image */
						let bgImg = require('../../assets/images/default.jpg');
						try {
							bgImg = require('../../assets/images/rooms/' + room.venueData.id + '_' + room.id + '.jpg');
						} catch (e) {
							console.error('Could not find image: ' + room.venueData.id + '_' + room.id + '.jpg');
						}

						/* Get venue name */
						let venueName = room.venueData.name;

						/* Get venue website */
						let website = null;
						if (room.venueData.website) {
							website = room.venueData.website
								.replace('https://www.', '')
								.replace('http://www.', '')
								.replace('http://', '')
								.replace('https://', '')
								.replace('www.', '');	
						}

						/* Add city name to venue name if it is not already in the name */
						if (room.locations && room.locations.length > 1) {
							venueName += ', ' + uiTexts.multipleCities[languageId];
						} else if (room.locations && room.locations.length === 1) {
							const locationData = 
								room.venueData.locations.find((l) => {return l.id === room.locations[0].locationId;});
							if (locationData) {
								const cityData = citiesData.find((c) => {return c.id === locationData.cityId;});
								const cityName = cityData ? cityData.name[languageId] : null;
								if (cityName && venueName.toLowerCase().indexOf(cityName.toLowerCase()) < 0) {
									venueName += ', ' + cityName;
								}
							}
						}
						
			
						/* Get link to venue */
						let linkTo = '/' + room.venueData.id;

						return (
							<div 
								key={room.venueData.id + '-' + room.id} 
								className={'Favorites-room' + (room.heart ? ' ' + room.heart : '')}
								style={{backgroundImage: 'url(' + bgImg + ')'}}
							>					
								<div className="Favorites-roomInfo">
									<div className="Favorites-roomName">{room.name[languageId]}</div>
									<Link className="Favorites-venueName" to={linkTo}>{venueName}</Link>
									<div className="Favorites-extraInfo">
										<div>
											<span>{uiTexts.teamSize[languageId]}:</span> 
											{' ' + (room.teamSizeMin === room.teamSizeMax 
												? room.teamSizeMin 
												: room.teamSizeMin + ' - ' 
													+ room.teamSizeMax)} {uiTexts.players[languageId]
											}
										</div>
										<div>
											<span>{uiTexts.timeLimit[languageId]}:</span>
											{' ' + room.minutes} {uiTexts.minutes[languageId]}
										</div>
										{room.languages && <div>
											<span>{uiTexts.languages[languageId]}:</span> 
											<LanguageIcons languageId={languageId} languageIds={room.languages} />
										</div>}
										{room.minimumAge && 
											<div><span>{uiTexts.age[languageId]}:</span> {room.minimumAge + '+'}</div>}
										{room.venueData.website && <div className="Favorites-website">
											<span>
												{uiTexts.website[languageId]}:</span> <a 
												href={room.venueData.website}
												target="_blank"
												rel="noopener noreferrer"	
											>{website}</a>
										</div>}
									</div>
								</div>
							</div>
						);
					})}
				</div>
			</div>

			{/* Bronze rooms */}
			<div className="Favorites-section bronze">
				<div className="Favorites-title"><span>{uiTexts.bronzeRoomsTitle[languageId]}</span></div>
				<div className="Favorites-rooms">
					{bronzeRooms.map((room) => {
						/* Get room image */
						let bgImg = require('../../assets/images/default.jpg');
						try {
							bgImg = require('../../assets/images/rooms/' + room.venueData.id + '_' + room.id + '.jpg');
						} catch (e) {
							console.error('Could not find image: ' + room.venueData.id + '_' + room.id + '.jpg');
						}

						/* Get venue name */
						let venueName = room.venueData.name;

						/* Get venue website */
						let website = null;
						if (room.venueData.website) {
							website = room.venueData.website
								.replace('https://www.', '')
								.replace('http://www.', '')
								.replace('http://', '')
								.replace('https://', '')
								.replace('www.', '');	
						}

						/* Add city name to venue name if it is not already in the name */
						if (room.locations && room.locations.length > 1) {
							venueName += ', ' + uiTexts.multipleCities[languageId];
						} else if (room.locations && room.locations.length === 1) {
							const locationData = 
								room.venueData.locations.find((l) => {return l.id === room.locations[0].locationId;});
							if (locationData) {
								const cityData = citiesData.find((c) => {return c.id === locationData.cityId;});
								const cityName = cityData ? cityData.name[languageId] : null;
								if (cityName && venueName.toLowerCase().indexOf(cityName.toLowerCase()) < 0) {
									venueName += ', ' + cityName;
								}
							}
						}
						
			
						/* Get link to venue */
						let linkTo = '/' + room.venueData.id;

						return (
							<div 
								key={room.venueData.id + '-' + room.id} 
								className={'Favorites-room' + (room.heart ? ' ' + room.heart : '')}
								style={{backgroundImage: 'url(' + bgImg + ')'}}
							>					
								<div className="Favorites-roomInfo">
									<div className="Favorites-roomName">{room.name[languageId]}</div>
									<Link className="Favorites-venueName" to={linkTo}>{venueName}</Link>
									<div className="Favorites-extraInfo">
										<div>
											<span>{uiTexts.teamSize[languageId]}:</span> 
											{' ' + (room.teamSizeMin === room.teamSizeMax 
												? room.teamSizeMin 
												: room.teamSizeMin + ' - ' 
													+ room.teamSizeMax)} {uiTexts.players[languageId]
											}
										</div>
										<div>
											<span>{uiTexts.timeLimit[languageId]}:</span>
											{' ' + room.minutes} {uiTexts.minutes[languageId]}
										</div>
										{room.languages && <div>
											<span>{uiTexts.languages[languageId]}:</span> 
											<LanguageIcons languageId={languageId} languageIds={room.languages} />
										</div>}
										{room.minimumAge && 
											<div><span>{uiTexts.age[languageId]}:</span> {room.minimumAge + '+'}</div>}
										{room.venueData.website && <div className="Favorites-website">
											<span>
												{uiTexts.website[languageId]}:</span> <a 
												href={room.venueData.website}
												target="_blank"
												rel="noopener noreferrer"	
											>{website}</a>
										</div>}
									</div>
								</div>
							</div>
						);
					})}
				</div>
			</div>
		</div>
	);
};


Favorites.propTypes = {
	type: PropTypes.string,
	languageId: PropTypes.string.isRequired,
	deviceInfo: PropTypes.object.isRequired,
	rooms: PropTypes.array.isRequired
};

export default Favorites;